"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Worms = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Options_1 = require("../Options");
var Worms = (function (_super) {
    __extends(Worms, _super);
    function Worms() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.WORMS,
            tags: [Tags_1.Tags.MICROBE],
            cost: 8,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.oxygen(4); }),
            metadata: {
                cardNumber: '129',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.plants(1).slash().microbes(2, { played: Options_1.played }); });
                }),
                description: 'Requires 4% oxygen. Increase your Plant production 1 step for every 2 Microbe tags you have, including this.',
            },
        }) || this;
    }
    Worms.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.PLANTS, Math.floor((player.getTagCount(Tags_1.Tags.MICROBE) + 1) / 2), { log: true });
        return undefined;
    };
    return Worms;
}(Card_1.Card));
exports.Worms = Worms;
